<script>
/** Utilities */
import AppResourceUtil from '../utilities/AppResourceUtil'
/** APIs */
import UserApi from '../api/UserApi';
import IssueApi from '../api/IssueApi';
/** UI Components */
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Notification } from 'buefy/dist/components/notification'


export default {
    name : "UserChangePasswordForm",
    components : {
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-notification' : Notification
    },
    props : {
        userProfile : Object
    },
    data() {
        return {
            oldPassword : "",
            newPassword : "",
            confirmPassword: "",
            oldPasswordValid : false,
            wrongOldPassword: false,
            sameWithOld : false,
            confirmNotMatched : false,
            errorMessage :  {
                oldPwd : "",
                samePwd : "",
                dontMatch: ""
            },
            validForm : false
        }
    },
    computed: {
        maskedPassword(){
            return "********";
        }
    },
    methods : {
        checkOldPassword(){
            if (this.oldPassword.trim()=="") {
                return false
            }
            this.errorMessage.oldPwd = "";
            UserApi.checkPassword({
                userId : this.userProfile.userId,
                password : this.oldPassword
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.oldPasswordValid = response.data.matched;
                        if (!this.oldPasswordValid) {
                            this.errorMessage.oldPwd = "Current password is invalid."
                        }
                        else {
                            this.errorMessage.oldPwd = "Current password is correct."
                        }
                    }
                    else {
                        this.promptServerError({response},'User.checkPassword');
                    }
                }
            })
            .catch(error=>{
                this.oldPasswordValid = false;
                this.promptServerError(error,'User.checkPassword');
            })
        },
        compare(){
            this.errorMessage.samePwd = "";
            this.errorMessage.dontMatch = "";
            this.confirmNotMatched = false;
            if (this.newPassword.trim()=="") {
                return false;
            }
            if (this.confirmPassword.trim()=="") {
                return false;
            }
            if (this.newPassword.trim()==this.confirmPassword.trim()) {
                if (this.oldPasswordValid==true) {
                    if (this.newPassword.trim()!=this.oldPassword.trim()) {
                        this.validForm = true;
                        return;
                    }
                    else {
                        this.errorMessage.samePwd = "Cannot use current password.";
                    }
                }
            }
            else {
                this.confirmNotMatched = true;
                this.errorMessage.dontMatch = "Passwords do not match.";
            }
            this.validForm = false;
        },
        reset(){
            this.oldPassword = "";
            this.newPassword = "";
            this.confirmPassword = "";
            this.oldPasswordValid = false;
            this.wrongOldPassword =false;
            this.sameWithOld = false;
            this.confirmNotMatched = false;
            this.errorMessage.oldPwd = "";
            this.errorMessage.samePwd = "";
            this.errorMessage.dontMatch = "";
            this.validForm = false;
        },
        triggerClose(){
            this.$emit('close');
        },
        triggerSubmit(){
            this.$emit('submit',this.newPassword)
        },
        submitError(errorData,api){   
            let obj = {
                email : this.userProfile.email,
                username : this.userProfile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.userProfile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        }
    }
}
</script>

<template>
    <div class="modal-card" style="width:auto">
        <header class="modal-card-head">
            <p class="modal-card-title">Change Password</p>
        </header>

        

        <section class="modal-card-body">

            <b-field label="Current Password"
                v-bind:type="{'is-danger':oldPasswordValid==false && errorMessage.oldPwd!='','is-success':oldPasswordValid}"
                v-bind:message="errorMessage.oldPwd">
                <b-input type="password"
                    value=""
                    password-reveal
                    v-model="oldPassword"
                    v-on:blur="checkOldPassword"
                    required>
                </b-input>
            </b-field>

            <b-notification
                type="is-danger"
                aria-close-label="Close notification"
                role="alert"
                v-if="errorMessage.dontMatch!=''">
                {{errorMessage.dontMatch}}
            </b-notification>

            <b-notification
                type="is-danger"
                aria-close-label="Close notification"
                role="alert"
                v-if="errorMessage.samePwd!=''">
                {{errorMessage.samePwd}}
            </b-notification>

            <b-field label="New Password"
                v-bind:type="{'is-danger':confirmNotMatched==true}">
                <b-input type="password"
                    value=""
                    password-reveal
                    v-model="newPassword"
                    v-on:blur="compare"
                    required>
                </b-input>
            </b-field>

            <b-field label="Confirm New Password"
                v-bind:type="{'is-danger':confirmNotMatched==true}">
                <b-input type="password"
                    value=""
                    password-reveal
                    v-model="confirmPassword"
                    v-on:blur="compare"
                    required>
                </b-input>
            </b-field>
        </section>

        <footer class="modal-card-foot">
            <div class="columns"
                style="width:100%;">
                <div class="column is-2 has-text-left">
                    <a class="button is-white"
                        v-on:click="triggerClose">
                        <span>Close</span>
                    </a>
                </div>
                <div class="column has-text-right">
                    <a class="button is-text is-light"
                        v-on:click="reset">
                        <span>Clear Form</span>
                    </a>
                    <a class="button is-success"    
                        v-on:click="triggerSubmit"
                        v-bind:disabled="!validForm">
                        <span>Save New Password</span>
                    </a>
                </div>

            </div>
        </footer>
    </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UserChangePasswordForm.vue